module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/internals/is-pure.js
// module id = lnCe
// module chunks = 04af